<template>
  <div class="couponadd" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据提交中..." element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div style="height:15px"></div>
    <ul class="lsls">
      <li>
        <h2>{{detail.title}}</h2>
      </li>
      <li @click="showDrawer">
        <span>SVIP标题</span>
        <input type="text" readonly :name="active" placeholder="请选择SVIP标题" :value="msg"/>
      </li>
      <li>
        <span>市场价</span>
        <input type="number" v-model="price" placeholder="请输入市场价"/>
        <font>元</font>
      </li>
      <li>
        <span>优惠价</span>
        <input type="number" v-model="rate" placeholder="请输入优惠价"/>
        <font>元</font>
      </li>

    </ul>
    <button class="addAddress" @click="save">立即创建</button>

    <el-drawer
      title="选择支付方式" :visible.sync="drawer" :direction="direction" size="50%" :withHeader="true">
      <ul>
        <li @click="ce(1)">
          <p>一个月</p>
          <a v-if="1==active"><img src="~assets/images/choose2.png" /></a>
          <a v-if="1!=active"><img src="~assets/images/choose1.png" /></a>
        </li>
        <li @click="ce(3)">
          <p>三个月</p>
          <a v-if="3==active"><img src="~assets/images/choose2.png" /></a>
          <a v-if="3!=active"><img src="~assets/images/choose1.png" /></a>
        </li>
        <li @click="ce(12)">
          <p>十二个月</p>
          <a v-if="12==active"><img src="~assets/images/choose2.png" /></a>
          <a v-if="12!=active"><img src="~assets/images/choose1.png" /></a>
        </li>
      </ul>
    </el-drawer>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        userData:[],
        price:'',
        rate:'',
        direction: 'btt',
        drawer:false,
        active:-1,
        msg:'',
        detail:[]
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    mounted() {
      this.beforeMount();
      this.getDetail()
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },
      ce:function(n){
        this.active = n;
        var msg = '';
        if(n == 1){
          msg = '一个月';
        }else if(n == 3){
          msg = '三个月';
        }else if(n == 12){
          msg = '十二个月';
        }
        this.msg = msg;
        this.drawer = false;
      },
      showDrawer:function(){
        this.drawer = true;
      },
      getDetail:function(){
        var that = this;
        var id = this.$route.query.id;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/product/getBusiness',
          params:{
            id:id
          }
        }).then(function(response){
          that.detail = response.data.data;
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },

      save:function(){
        var that = this;
        if(that.active == -1){
          alert('请选择SVIP标题');
          return false;
        }
        if(that.price == ''){
          alert('请输入金额');
          return false;
        }
        if(that.rate == ''){
          alert('请输入金额');
          return false;
        }
        var id = this.$route.query.id;
        that.fullscreenLoading = true;
        this.axios({
          method:'post',
          url:that.$host+'home/product/addSvip',
          params:{
            price:that.price,
            type:that.active,
            title:that.msg,
            rate:that.rate,
            mall_id:id
          }
        }).then(function(response){
          that.fullscreenLoading = false;
          var res = response.data;
          if(res.status == 200){
            that.$router.go(-1)
          }else{
            alert(res.message);
          }
          
        }).catch(err=>{
          that.fullscreenLoading = false;
            console.log('请求失败:'+err);
        });
        return false;
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .couponadd{
    max-width:640px;
    background:#f7faff;
    margin:0 auto;
  }
  .couponadd ul.lsls{
    display:block;
    width:93%;
    background:#fff;
    margin:0 auto;
    margin-bottom:80px;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius: 10px;
  }
  .couponadd ul.lsls li{
    width:92%;
    margin:0 auto;
    border-bottom:solid 1px #EBF2FF;
    padding:15px 0;
    position: relative;
  }
  .couponadd ul.lsls li font{
    position:absolute;
    right:15px;
    bottom:15px;
    font-size:16px;
    color:#FF751A
  }
  .couponadd ul.lsls li:first-child{
    border-bottom:none;
  }
  .couponadd ul li:first-child h2{
    font-size:18px
  }
  .couponadd li:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .couponadd ul li span{
    display:block;
    width:100%;
    font-size:16px;
    padding-bottom:15px
  }
  .couponadd ul li input{
    display:block;
    width:100%;
    background:none;
    border:none;
    outline:none;
    font-size:16px;
    margin-top:1px;
  }
  .couponadd ul li .checkbox{
    float:right;
    width:auto !important;
    margin-right:30px;
    margin-top:4px
  }
  .couponadd ul li textarea{
    float:left;
    width:78%;
    height:50px;
    background:none;
    border:none;
    outline:none;
    font-size:15px;
    resize: none;
  }
  .couponadd .addAddress{
    display:block;
    margin:0 auto;
    width:80%;
    height:45px;
    border:none;
    background:#2F78FF;
    color:#fff;
    font-size:16px;
    border-radius:45px;
  }


  .couponadd .el-drawer__wrapper ul{
    width:90%;
    margin:0 auto;
  }
  .couponadd .el-drawer__wrapper li{
    border-bottom:solid 1px #EBF2FF;
    padding:15px 0 10px 0;
    position:relative;
  }
  .couponadd .el-drawer__wrapper li:last-child{
    border-bottom:none;
  }

  .couponadd .el-drawer__wrapper li p{
    padding-bottom:7px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    padding-left:45px;
  }
  .couponadd .el-drawer__wrapper li p:last-child{
    color: #666;
  }

  .couponadd .el-drawer__wrapper li a{
    position:absolute;
    left:0;
    top:50%;
    transform: translateY(-50%);
    color: #2F78FF;
    font-size:18px;
  }
  .couponadd .el-drawer__wrapper li a img{
    display:block;
    width:30px;
  }
</style>